// extracted by mini-css-extract-plugin
export default {"root":"WithTooltip_root__GZVfd","tooltip":"WithTooltip_tooltip__FTlfD","position-top":"WithTooltip_position-top__cFG5Z","position-right":"WithTooltip_position-right__FYAuD"};